import { schema } from 'normalizr';

import { opDefSchema } from 'modules/opDefs/data/entities';
// import type { OpDef } from 'modules/opDefs/data/entities';
import {
  processMaterialSchema,
  processFinishSchema,
} from 'modules/processes/data/entities';

// import type {
//   BaseProcess,
//   LegacyOpFactoryFields,
//   TemplatedOpFactoryFields,
//   CNCOpFactoryFields,
// } from 'modules/processes/data/entities';

// type BaseProcessDetails = {
//   ...$Exact<BaseProcess>,
//   operationDefinitions: Array<OpDef>,
// };

// export type Process =
//   | {
//       ...$Exact<BaseProcessDetails>,
//       ...$Exact<LegacyOpFactoryFields>,
//     }
//   | {
//       ...$Exact<BaseProcessDetails>,
//       ...$Exact<TemplatedOpFactoryFields>,
//     }
//   | {
//       ...$Exact<BaseProcessDetails>,
//       ...$Exact<CNCOpFactoryFields>,
//     };

export const processSchema = new schema.Entity('processes', {
  operationDefinitions: [opDefSchema],
  processMaterials: [processMaterialSchema],
  processFinishes: [processFinishSchema],
});

export const addOnSchema = new schema.Entity('addOns', {});
export const profitItemSchema = new schema.Entity('profitItems', {});
export const discountSchema = new schema.Entity('discounts', {});
